import React from "react";
import axios from "axios";
import { Checkbox, Divider, message, Drawer } from "antd";
import { useState, useEffect } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

import { BETA_FEATURES } from "../../constants/betaFeatures";

import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext"; 

const CheckboxGroup = Checkbox.Group;
const betaFeatureOptions = Object.values(BETA_FEATURES).map(feature => feature.label);

const UserBetaFeatures = ({ userId, betaFeatures}) => {
  const { permissions } = usePermissions();
  
  const [checkedList, setCheckedList] = useState(betaFeatures);
  const [checkAll, setCheckAll] = useState(
    betaFeatures.length === betaFeatureOptions.length
  );
  const [disabled, setDisabled] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    setDisabled(!permissions?.includes(PERMISSIONS.UPDATE_BETA_FEATURES));
  }, [permissions]); 

  const onChange = async (list) => {
    setCheckedList(list);
    setCheckAll(list.length === betaFeatureOptions.length);

    try {
      await axios.put(`/api/user/${userId}/beta-features`, {
        betaFeatures: list,
      });

      message.info("Updated");
    } catch (err) {
      message.error("Error when updating User Beta features.");
    }
  };
  const onCheckAllChange = async (e) => {
    setCheckedList(e.target.checked ? betaFeatureOptions : []);
    setCheckAll(e.target.checked);

    const betaFeatures = e.target.checked ? betaFeatureOptions : [];

    try {
      await axios.put(`/api/user/${userId}/beta-features`, {
        betaFeatures: betaFeatures,
      });

      message.info("Updated");
    } catch (err) {
      message.error("Error when updating User Beta features.");
    }
  };

  const label = `${checkAll ? "Enable All" : "Disable All"}`;
  return (
    <>
      <React.Fragment>
        Description <InfoCircleOutlined onClick={() => setDrawerVisible(true)} />
        <Drawer
          title="Features"
          placement="right"
          onClose={() => setDrawerVisible(false)}
          visible={drawerVisible}
          width={736}
        >
          {Object.values(BETA_FEATURES).map(feature => (
            <div className="mb-2">
              <strong>{feature.label}</strong>
              <br />
              {feature.desc}
            </div>
          ))}
        </Drawer>
      </React.Fragment>

      <Divider />
      <Checkbox
        checked={checkAll}
        disabled={disabled}
        onChange={onCheckAllChange}
      >
        {label}
      </Checkbox>
      <Divider />
      <CheckboxGroup
        options={betaFeatureOptions}
        value={checkedList}
        onChange={onChange}
        disabled={disabled}
      />
    </>
  );
};

export default UserBetaFeatures;
